import React, { FC } from 'react';
import { CardExpandedProps, CardProps, CardTitleWithIconProps } from './Card.types';
import {
  CardCloseButton,
  CardContainer,
  CardExpandBody,
  CardExpandButtonIcon,
  CardExpandContainer,
  CardExpandHeader,
  CardTitleWithIconContainer,
} from './Card.styles';
import { TrevorIcon } from '../TrevorIcon';
import { Heading } from '../TypographyNew';

export const Card: FC<CardProps> = ({ children, onClose, ...props }) => {
  return (
    <CardContainer {...props}>
      {onClose && <CardCloseButton onClick={onClose} />}
      {children}
    </CardContainer>
  );
};

export const CardExpand: FC<CardExpandedProps> = ({
  header,
  children,
  expanded,
  onExpand,
  padding,
  gap,
  alignItems, hideExpandButton,
  ...props
}) => {
  return (
    <CardExpandContainer {...props}>
      <CardExpandHeader padding={padding} onClick={onExpand}>
        {header}
        {!hideExpandButton && <CardExpandButtonIcon flip={expanded} />}
      </CardExpandHeader>
      {expanded && (
        <CardExpandBody padding={padding} gap={gap} alignItems={alignItems}>
          {children}
        </CardExpandBody>
      )}
    </CardExpandContainer>
  );
};

export const CardTitleWithIcon: FC<CardTitleWithIconProps> = ({
  iconName,
  title,
}) => {
  return (
    <CardTitleWithIconContainer>
      <TrevorIcon name={iconName} size="xl" />
      <Heading variant={3}>{title}</Heading>
    </CardTitleWithIconContainer>
  );
};
